export enum AppraisalMeetingEmployeeProgressStatus {
  NotStarted = 0,
  InProgress = 1,
  Submitted = 2
}
